import { render, staticRenderFns } from "./DonutChart82.vue?vue&type=template&id=e2b5cb3c&scoped=true"
import script from "./DonutChart82.vue?vue&type=script&lang=js"
export * from "./DonutChart82.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b5cb3c",
  null
  
)

export default component.exports